import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import CategoryPage from "@/pages/category/page";
import MangaDetailPage from "@/pages/manga/detail/page";
import ChapterPage from "@/pages/manga/chapter/page";
import AboutPage from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/category/:slug",
    element: <CategoryPage />,
  },
  {
    path: "/manga/:slug",
    element: <MangaDetailPage />,
  },
  {
    path: "/manga/:slug/chapter/:chapterId",
    element: <ChapterPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;